import React, {
  useContext,
  forwardRef,
} from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PoliticalAdsDialog, PoliticalAdsDialogHandle } from './political-ads-dialog';

export const CampaignPoliticalAdsDialog = forwardRef<
  PoliticalAdsDialogHandle
>((_, ref) => {
  const i18n = useContext(I18nContext);

  return (
    <PoliticalAdsDialog
      ref={ref}
      dialogContentText={i18n.getString(_TL_('You cannot create campaigns that are intended for political advertising.'))}
    />
  );
});
